import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getPlans } from "../../store/actions";
import { Link, Redirect } from "react-router-dom";
import styled from "styled-components";
import HeaderPlans from "../organisms/HeaderPlans";
import BodyPlans from "../organisms/BodyPlans";
import ModalCardLoader from "../molecules/ModalCardLoader";
import { executeTaggeo } from "../../store/actions";
import ServiceNotAvalible from "../organisms/ServiceNotAvalible";
import OfferTelcelWithoutLine from "../organisms/OfferTelcelWithoutLine";
import { CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE, CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO, SERVICE_ID_TELCEL_PAQUETES_POSPAGO } from "../../constants";
import { getUserInfoLiteSelector } from "../../store/selectors/paymentsSelectors";
import { getPaymentFlowForTaggeo, getRequirementsAdvancementClaroPay } from "../organisms/utils";
const Container = styled.div`
  width: 100%;
  overflow: scroll;
  background: ${(props) => (props.background ? props.background : "#f7f8f8")};
  min-height: 100vh;
`;

class PlansContainer extends Component {
  constructor(props) {
    super(props);
    const { paymentMethods } = this.props;

    const isAnonimous =
      this.props.isAnonimous ||
      (this.props.isContainerTelcel &&
        paymentMethods &&
        paymentMethods.cardList.length === 0 &&
        !paymentMethods.hasN2)
        ? true
        : false;

    this.state = {
      serviceDataGeneric:
        this.props.paymentsConfig.services[this.props.serviceConfigIndex]
          .serviceData.generic,
      serviceDataInfo:
        this.props.paymentsConfig.services[this.props.serviceConfigIndex]
          .serviceData.info,
      offerTelcel: !isAnonimous
        ? this.props.paymentsConfig.services[this.props.serviceConfigIndex]
            .offerTelcel
        : this.props.paymentsConfig.services[this.props.serviceConfigIndex]
            .offerTelcelAnonimo,
      disableSeeMoreButton: false,
      isAnonimous: isAnonimous,
    };
  }

  componentDidMount() {
    if (
      this.state.serviceDataInfo.categoryId === 8 ||
      this.state.serviceDataInfo.categoryId === 32 ||
      this.state.serviceDataInfo.categoryId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO
    ) {
      this.setState({ disableSeeMoreButton: true });
    } else {
      let params = {
        action: "View",
        step: this.state.serviceDataInfo.serviceTitleLabel,
        service: this.props.tagServiceId,
      };

      if (this.props.isContainerTelcel) {
        const msisdn = this.props.paymentsConfig ? this.props.paymentsConfig.msisdn : undefined;
        const flow = getPaymentFlowForTaggeo(
          this.props.isAnonimous, 
          msisdn, 
          this.props.paymentMethods
        );

        params = { ...params, flow };
      }
      this.props.executeTaggeo(params);
    }
    this.props.getPlans(
      this.state.serviceDataInfo.serviceId,
      this.state.serviceDataInfo.categoryPlansId
        ? this.state.serviceDataInfo.categoryPlansId
        : this.state.serviceDataInfo.categoryId
    );
  }

  componentDidUpdate(prevProps) {
    const { plans } = this.props;
    if (prevProps.plans !== plans) {
      this.validateFromAdelanto();
    }

    if (
      this.state.serviceDataInfo.serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO &&
      this.state.serviceDataInfo.categoryId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO
    ) {
      let params = {
        action: "View",
        step: "Paquetes Internet por tiempo para tu Plan",
        service: this.props.tagServiceId,
      };

      if (this.props.isContainerTelcel) {
        const msisdn = this.props.paymentsConfig ? this.props.paymentsConfig.msisdn : undefined;
        const flow = getPaymentFlowForTaggeo(
          this.props.isAnonimous, 
          msisdn, 
          this.props.paymentMethods
        );

        params = { ...params, flow };
      }
      this.props.executeTaggeo(params);
    }
  }

  validateFromAdelanto = () => {
    const {
      history,
      plans,
      isContainerTelcel,
      paramsNewOfferTelcel,
      tagServiceId,
      sdkVersion,
      paymentsConfig,
      isClaroPartner,
      goToMicroappAdelanto,
      paymentAmountFromUrl,
      serviceConfigIndex,
    } = this.props;
    if (goToMicroappAdelanto) {
      const fiftyPlan = plans.detail.filter(
        (item) => item.cost === parseInt(paymentAmountFromUrl)
      )[0];
      history.push({
        pathname: "/plans",
        state: {
          sdkVersion: sdkVersion,
          paymentsConfig: paymentsConfig,
          isClaroPartner: isClaroPartner,
          amountPlan: paymentAmountFromUrl,
          productId: fiftyPlan.idExternal,
          serviceConfigIndex: serviceConfigIndex,
          tagServiceId: tagServiceId,
          paramsNewOfferTelcel: paramsNewOfferTelcel,
          isContainerTelcel: isContainerTelcel,
          idCategory: plans.service.id,
          mb: fiftyPlan.mb,
          isAdvancementClaroPay: true,
        },
      });
    }
  };

  handleButonSeeMore = () => {
    this.setState({ disableSeeMoreButton: true });
  };

  executeTaggeoHandle = (cost, productId) => {
    const { executeTaggeo } = this.props;
    const { serviceTitleLabel } = this.state.serviceDataInfo;
    let params = {
      action: "Click Lo quiero",
      step: serviceTitleLabel,
      service: this.props.tagServiceId,
    };

    if (this.props.isContainerTelcel) {
      const msisdn = this.props.paymentsConfig ? this.props.paymentsConfig.msisdn : undefined;
      const flow = getPaymentFlowForTaggeo(
        this.props.isAnonimous, 
        msisdn, 
        this.props.paymentMethods
      );

      params = { ...params, flow, package: String(cost) };
    }

    executeTaggeo(params);
  };

  render() {
    const {
      errorPlans,
      paramsNewOfferTelcel,
      isContainerTelcel,
      isClaroPartner,
      userInfoLite,
    } = this.props;
    const {
      offerTelcel,
      serviceDataInfo: { categoryPlansId, withOfferTelcel },
      isAnonimous,
    } = this.state;
    let title = "";
    let subtitle = "";
    let idService = "";
    let planId = "";
    if (this.props.plans) {
      title = this.props.plans.service.title;
      subtitle = this.props.plans.service.subtitle;
      idService =
        this.props.plans &&
        this.props.plans.service &&
        this.props.plans.service.idService;
      planId =
        this.props.plans &&
        this.props.plans.service &&
        this.props.plans.service.id;
    }
    return (
      <>
        {errorPlans ? (
          <ServiceNotAvalible />
        ) : (
          <Container
            background={
              isContainerTelcel && !isClaroPartner ? "#f6f6f6" : "#f7f8f8"
            }
          >
            <HeaderPlans
              dataConfigLogo={this.state.serviceDataGeneric.logo.data}
              titlePlans={title}
              subtitlePlans={subtitle}
              isContainerTelcel={isContainerTelcel}
              isClaroPartner={isClaroPartner}
              idService={idService}
              planId={planId}
              isLoadingGetPlans={this.props.isLoadingGetPlans}
            />
            <BodyPlans
              plans={this.props.plans}
              disableSeeMoreButton={this.state.disableSeeMoreButton}
              handleButonSeeMore={this.handleButonSeeMore}
              paymentsConfig={this.props.paymentsConfig}
              sdkClaroVersion={this.props.sdkVersion}
              isClaroPartner={this.props.isClaroPartner}
              serviceConfigIndex={this.props.serviceConfigIndex}
              tagServiceId={this.props.tagServiceId}
              paymentMethod={
                paramsNewOfferTelcel
                  ? paramsNewOfferTelcel.creditCardInfo
                  : false
              }
              approvedToAdvancementClaroPay={getRequirementsAdvancementClaroPay(
                userInfoLite
              )}
              executeTaggeoHandle={this.executeTaggeoHandle}
              paramsNewOfferTelcel={paramsNewOfferTelcel}
              withOfferTelcelWithoutLine={
                categoryPlansId ===
                  CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE || withOfferTelcel
              }
              isContainerTelcel={this.props.isContainerTelcel}
              isAnonimous={isAnonimous}
            />
            {categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
            withOfferTelcel ? (
              <OfferTelcelWithoutLine
                offerTelcel={offerTelcel}
                planType={""}
                history={this.props.history}
                subtitleAlign={"left"}
                subtitleMargin={"5% 0% 2% 5%"}
                logoIsVisible={"none"}
                subtitle={"Descubre otras opciones"}
                paramsNewOfferTelcel={paramsNewOfferTelcel}
                step={this.state.serviceDataInfo.serviceTitleLabel}
                event={"pay_service_or_tae"}
                isContainerTelcel={isContainerTelcel}
                isClaroPartner={isClaroPartner}
                quitPlanType={true}
              />
            ) : (
              <></>
            )}
          </Container>
        )}
        <ModalCardLoader isOpen={this.props.isLoadingGetPlans} />
      </>
    );
  }
}

function mapStateToProps(state) {
  const userInfoLite = getUserInfoLiteSelector(state);

  return {
    paymentMethods: state.payments.paymentMethods,
    plans: state.payments.plans,
    isLoadingGetPlans: state.payments.isLoadingGetPlans,
    errorPlans: state.payments.errorPlans,
    isAnonimous: state.payments.isAnonimous,
    userInfoLite: userInfoLite,
    paymentAmountFromUrl: state.payments.getPaymentAmountFromUrl,
    productId: state.payments.getProductIdFromUrl,
    goToMicroappAdelanto: state.payments.goToMicroappAdelanto,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getPlans,
      executeTaggeo,
    },
    dispatch
  );
}

PlansContainer = connect(mapStateToProps, mapDispatchToProps)(PlansContainer);

export default PlansContainer;
